// src/components/EmailLinkLanding.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function EmailLinkLanding() {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const adminDoc = await getDoc(doc(db, 'admins', user.uid));
        setIsAdmin(adminDoc.exists());
      } else {
        setIsAdmin(false);
      }
    });
    return unsubscribe;
  }, []);

  return (
    <div className="container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      textAlign: 'center',
      padding: '2rem'
    }}>
      <h1>Avaa linkki puhelimellasi</h1>
      <p style={{ fontSize: '1.2rem', maxWidth: '500px', marginTop: '1rem' }}>
        Tämä sähköpostiin lähetetty kirjautumislinkki on tarkoitettu avattavaksi puhelimella.
      </p>
      {isAdmin && (
        <Link to="/admin" style={{ marginTop: '2rem' }}>
          <button className="btn-primary">Go to Admin Panel</button>
        </Link>
      )}
    </div>
  );
}

export default EmailLinkLanding;
